import { Component, OnInit, ViewChild } from '@angular/core';

import { PoCheckboxGroupOption, PoModalComponent, PoButtonModule, PoFieldModule, PoModalModule, PoModalAction, PoInputComponent, PoLoadingModule, PoNotificationService } from '@po-ui/ng-components';
import { PoPageLogin, PoPageLoginCustomField, PoPageLoginLiterals, PoPageLoginModule } from '@po-ui/ng-templates';
import { ApiService } from '../../shared/service/api.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TokenService } from '../../shared/service/token.service';
import { AuthService } from '../../shared/service/auth.service';
import { FormControl, FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  imports: [PoButtonModule, PoFieldModule, PoModalModule, PoPageLoginModule, CommonModule, PoLoadingModule, FormsModule],
})
export class LoginComponent implements OnInit {
  @ViewChild('poModal', { static: false }) poModal!: PoModalComponent;
  @ViewChild('poModalBranch', { static: false }) poModalBranch!: PoModalComponent;
  msgError!: string;
  background!: string;
  contactEmail!: string;
  customField!: PoPageLoginCustomField;
  customLiterals!: PoPageLoginLiterals;
  environment!: string;
  exceededAttempts!: number;
  secondaryLogo!: string;
  languages!: any;
  literals!: string;
  login!: string;
  loginPattern!: string;
  loginError!: string;
  loginErrors!: Array<string>;
  logo!: string;
  passwordError!: string;
  passwordErrors!: Array<string>;
  passwordPattern!: string;
  productName!: string;
  properties!: Array<string>;
  recovery!: string;
  registerUrl!: string;
  support!: string;
  authReturn!: any;
  mfaInput!: any;
  branchInput!: any;
  branchList: any = [{ label: 'default', value: '0' }];

  infoLogin!: any;
  infoPassword!: any;
  infoTenant!: any;
  show: boolean = false;
  size: string = '';
  text: any = null;
  isLoading: boolean = false;

  primaryAction: PoModalAction = {
    action: async () => {
      this.poModal.close();
      await this.addMfaValue();
    },
    label: 'Confirmar'
  };
  secondaryAction: PoModalAction = {
    action: () => {
      this.poModal.close();
    },
    label: 'Sair'
  };
  primaryActionBranch: PoModalAction = {
    action: () => {
      this.tokenService.saveBranch(this.branchInput);
      // this.tokenService.saveNameBranch();
      this.getCustomerTokenAndGoHome();
    },
    label: 'Confirmar'
  };
  secondaryActionBranch: PoModalAction = {
    action: () => {
      this.tokenService.cleanVariablesStorage();
      this.poModalBranch.close();
    },
    label: 'Sair'
  };

  public readonly propertiesOptions: Array<PoCheckboxGroupOption> = [
    { value: 'hideRememberUser', label: 'Hide remember user' },
    { value: 'loading', label: 'Loading' },
    { value: 'click-out', label: 'Click Out' },
    { value: 'hide-close', label: 'Hide Close' },
  ];

  constructor(
    private router: Router,
    private authService: AuthService,
    private tokenService: TokenService,
    private api: ApiService,
    private poNotification: PoNotificationService,
    private apiService: ApiService
  ) { }

  closeModalMfa() {
    this.poModal.close();
  }

  closeModal() {
    this.poModalBranch.close();
  }

  openModalMfa() {
    this.poModal.open();
  }

  getBranchsList() {
    return this.api.getBranchList();
  }

  setMfa(event: any) {
    this.mfaInput = event;
  }

  setBranch(event: any) {
    this.branchInput = event;
    const branchName = this.branchList.find((item: any) => item.value == event);
    this.tokenService.saveBranchName(branchName.label);
  }

  getCustomerTokenAndGoHome() {
    if (this.branchInput !== '' && localStorage.getItem('tokenV2') !== '') {
      this.poModalBranch.close();
      this.router.navigate(['/home']);
    }
  }

  openModal() {
    this.isLoading = true;
    this.getBranchsList().subscribe({
      next: (data: any) => {
        this.branchList = [];
        data.items.map((el: any) => {
          this.branchList.push({ label: el.branchCode.toString() + ' - ' + el.personName, value: el.branchCode.toString() });
        });
      },
      complete: () => {
        this.isLoading = false;
        if (this.branchList.length == 0) {
          this.poNotification.error('Usuário não possui empresas liberadas');
          return;
        }

        if (this.branchList.length == 1) {
          this.setBranch(this.branchList[0].value);
          this.tokenService.saveBranch(this.branchList[0].value);
          this.getCustomerTokenAndGoHome();
          return;
        }

        this.poModalBranch.open();
      }
    });
  }

  async addMfaValue() {
    this.isLoading = true;
    var authenticated = await this.authService.postMfa(this.infoLogin, this.infoPassword, this.infoTenant, this.mfaInput)
    this.isLoading = false;
    this.poModal.close();
    if (!authenticated) return;

    this.openModal();
  }

  ngOnInit() {
    this.restore();
    this.customField.value = this.tokenService.getTenant()?.toString();

    var token = this.tokenService.getTokenV2();

    if (token != null && this.tokenService.isNotExpiredToken(token)) {
      this.router.navigate(['/home']);
    }
  }

  addLoginError() {
    this.loginErrors.push(this.loginError);
    this.loginError = '';
  }

  addPasswordError() {
    this.passwordErrors.push(this.passwordError);
    this.passwordError = '';
  }

  changeLiterals() {
    try {
      this.customLiterals = JSON.parse(this.literals);
    } catch {
      this.customLiterals = {};
    }
  }

  loginSubmit(formData: PoPageLogin) {
    this.show = true;
    this.infoLogin = formData.login;
    this.infoPassword = formData.password;
    this.infoTenant = `${this.customField.value}`;
    this.tokenService.saveTenant(`${this.customField.value}`);
    this.tokenService.saveUsername(formData.login);
    this.verifyMfa(formData);
  }

  async verifyMfa(item: any) {
    this.isLoading = true;
    let trim = item.login.split('@');
    if (this.isTotvsDomain(trim[1])) {
      this.openModalMfa();
    } else {
      var authenticated = await this.authService.postLogin(item.login, item.password, item.tenant);

      this.isLoading = false;
      if (!authenticated) return;

      this.openModal();
    }
  }

  isTotvsDomain(domain: string) {
    return domain == 'totvs.com.br' || domain == 'totvspartners.com.br';
  }

  onChangeCustomProperties() {
    this.customField = Object.assign({}, this.customField);
  }

  restore() {
    this.size = 'sm';
    this.text = null;
    this.properties = [];
    this.background = '';
    this.contactEmail = '';
    this.customField = { property: 'tenant', placeholder: 'Informe seu tenant' };
    this.customLiterals = {
      highlightInfo: '',
      welcome: 'Boas-vindas',
      loginErrorPattern: 'Login obrigatório',
      loginHint: 'Caso não possua usuário entre em contato com o suporte',
      loginPlaceholder: 'Usuário',
      passwordErrorPattern: 'Senha obrigatória',
      passwordPlaceholder: 'Senha',
      customFieldErrorPattern: 'Campo customizado inválido',
      customFieldPlaceholder: 'Por favor insira um valor',
      rememberUserHint: 'Esta opção pode ser desabilitada nas configurações do sistema',
      submitLabel: 'Entrar',
      submittedLabel: 'Carregando...',
    };
    this.environment = '';
    this.exceededAttempts = 0;
    this.secondaryLogo = '';
    this.languages = [];
    this.literals = '';
    this.login = '';
    this.loginPattern = '';
    this.loginError = '';
    this.loginErrors = [];
    this.logo = '/assets/images/logo-totvs-azul-escuro.png';
    this.passwordError = '';
    this.passwordErrors = [];
    this.passwordPattern = '';
    this.passwordError = '';
    this.passwordErrors = [];
    this.productName = 'TOTVS Moda - Coletor';
    this.recovery = 'https://www.google.com.br/';
    this.registerUrl = '';
    this.support = '';
  }
}
